import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "product",
    "fromWarehouse", "fromLocation",
    "toWarehouse", "toLocation",
    "balanceHint"
  ]

  connect() {
    this.optionsCache = new Map()

    const selects = [
      this.fromWarehouseTarget, this.fromLocationTarget,
      this.toWarehouseTarget, this.toLocationTarget
    ]

    selects.forEach(el => {
      this.optionsCache.set(el, this.readOptions(el))
    })

    this.waitForTomSelect(selects, () => this.filterAll())
  }

  productChanged() {
    this.filterAll()
    this.updateBalanceHint()
  }

  fromWarehouseChanged() {
    this.applyFilter(this.fromLocationTarget, this.locationMatcher(this.fromWarehouseTarget))
    this.updateBalanceHint()
  }

  fromLocationChanged() {
    this.updateBalanceHint()
  }

  toWarehouseChanged() {
    this.applyFilter(this.toLocationTarget, this.locationMatcher(this.toWarehouseTarget))
  }

  filterAll() {
    const productId = this.getValue(this.productTarget)

    const warehouseMatcher = (opt) => {
      if (!productId) return true
      return opt.productIds.includes(productId)
    }

    this.applyFilter(this.fromWarehouseTarget, warehouseMatcher)
    this.applyFilter(this.toWarehouseTarget, warehouseMatcher)
    this.applyFilter(this.fromLocationTarget, this.locationMatcher(this.fromWarehouseTarget))
    this.applyFilter(this.toLocationTarget, this.locationMatcher(this.toWarehouseTarget))
  }

  locationMatcher(warehouseTarget) {
    const productId = this.getValue(this.productTarget)
    const warehouseId = this.getValue(warehouseTarget)

    return (opt) => {
      if (warehouseId && opt.warehouseId !== warehouseId) return false
      if (productId && !opt.productIds.includes(productId)) return false
      return true
    }
  }

  applyFilter(selectElement, filterFn) {
    const tomSelect = selectElement.tomselect
    if (!tomSelect) return

    const allOptions = this.optionsCache.get(selectElement)
    if (!allOptions) return

    const currentValue = tomSelect.getValue()
    tomSelect.clear(true)
    tomSelect.clearOptions()

    let currentValueValid = false

    allOptions.forEach(opt => {
      if (!opt.value) return
      if (filterFn(opt)) {
        tomSelect.addOption({ value: opt.value, text: opt.text, ...opt.dataAttrs })
        if (currentValue === opt.value) currentValueValid = true
      }
    })

    tomSelect.refreshOptions(false)

    if (currentValue && currentValueValid) {
      tomSelect.setValue(currentValue, false)
    }
  }

  readOptions(selectElement) {
    return Array.from(selectElement.querySelectorAll("option")).map(option => ({
      value: option.value,
      text: option.textContent,
      warehouseId: option.dataset.warehouseId,
      productIds: option.dataset.productIds ? option.dataset.productIds.split(",") : [],
      dataAttrs: Object.keys(option.dataset).reduce((acc, key) => {
        acc[key] = option.dataset[key]
        return acc
      }, {})
    }))
  }

  updateBalanceHint() {
    if (!this.hasBalanceHintTarget) return

    const productId = this.getValue(this.productTarget)
    const locationId = this.getValue(this.fromLocationTarget)

    if (!productId || !locationId) {
      this.balanceHintTarget.textContent = ""
      return
    }

    const options = this.optionsCache.get(this.fromLocationTarget) || []
    const option = options.find(o => o.value === locationId)

    if (option && option.dataAttrs.balances) {
      try {
        const balances = JSON.parse(option.dataAttrs.balances)
        const qty = balances[productId]
        if (qty !== undefined) {
          this.balanceHintTarget.textContent = `Остаток: ${parseFloat(qty).toLocaleString("ru-RU")}`
        } else {
          this.balanceHintTarget.textContent = "Остаток: 0"
        }
      } catch {
        this.balanceHintTarget.textContent = ""
      }
    } else {
      this.balanceHintTarget.textContent = ""
    }
  }

  getValue(selectElement) {
    return selectElement.tomselect?.getValue() || selectElement.value
  }

  waitForTomSelect(targets, callback) {
    const check = setInterval(() => {
      if (targets.every(t => t.tomselect)) {
        clearInterval(check)
        callback()
      }
    }, 50)
    setTimeout(() => clearInterval(check), 2000)
  }
}
